import { TPaywallTemplate } from "app/schema/paywallTemplate/paywallTemplate"
import { TElement } from "app/schema/paywallTemplate/element/element"

export const getElementById = (
  id: string | null,
  parsedJson?: TPaywallTemplate
): TElement | null => {
  if (!id || !parsedJson) return null

  let foundElement: TElement | null = null

  const findElement = (id: string, content: TElement[]) => {
    for (const element of content) {
      if (element.id.toLocaleLowerCase() === id.toLocaleLowerCase()) {
        foundElement = element
        return
      }

      if (element.children) {
        findElement(id, element.children)
      }
    }
  }

  const { backgroundContent, mainContent, cardContent } = parsedJson

  findElement(id, backgroundContent || [])
  findElement(id, mainContent || [])
  findElement(id, cardContent || [])

  return foundElement
}
